import { IAction, isType } from '@zaibot/fsa';
import { Status } from './dialog';

import STATUS_HIDE from './actions/HIDE';
import STATUS_SHOW from './actions/SHOW';

interface IState {
    visible: boolean;
    message: string;
    status: Status;
}
const emptyState: IState = { visible: false, message: '', status: null };
export const selector = (state: any) => state.statusDialog as IState;

export const reducer = (state = emptyState, action: IAction) => {
  if (isType(action, STATUS_SHOW)) {
    return { ...state, visible: true, message: action.payload.message, status: action.payload.status };
  }
  if (isType(action, STATUS_HIDE)) {
    return { ...state, visible: false };
  }
  return state;
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/statusDialog/reducer.tsx